import type { ReactNode } from 'react';
import {
  AdministrationIcon,
  CamerasIcon,
  LogoutIcon,
} from './icons';

export interface NavItem {
  id: string;
  label: string;
  path?: string;
  icon: ReactNode;
  enabled: boolean;
  reason?: string;
  separated?: boolean;
  isAction?: boolean;
}

export interface NavPermissionFlags {
  canManageUsers?: boolean;
  canManageRoles?: boolean;
}

export function buildNavItems(flags: NavPermissionFlags = {}): NavItem[] {
  const items: NavItem[] = [
    {
      id: 'nvr',
      label: 'NVR',
      path: '/dashboard',
      icon: <CamerasIcon />,
      enabled: true,
    },
  ];

  if (flags.canManageUsers) {
    items.push({
      id: 'admin-users',
      label: 'Users',
      path: '/admin/users',
      icon: <AdministrationIcon />,
      enabled: true,
    });
  }

  if (flags.canManageRoles) {
    items.push({
      id: 'admin-roles',
      label: 'Roles',
      path: '/admin/roles',
      icon: <AdministrationIcon />,
      enabled: true,
    });
  }

  items.push({
    id: 'logout',
    label: 'Logout',
    icon: <LogoutIcon />,
    enabled: true,
    isAction: true,
    separated: true,
  });

  return items;
}

export function findActiveNavItem(pathname: string, items: NavItem[]): NavItem | null {
  if (pathname.startsWith('/cameras/')) {
    return items.find((item) => item.id === 'nvr') ?? null;
  }
  if (pathname.startsWith('/admin/')) {
    const admin = items.find(
      (item) => item.enabled && item.path && pathname.startsWith(item.path),
    );
    if (admin) return admin;
  }
  const exact = items.find((item) => item.enabled && item.path === pathname);
  if (exact) return exact;
  const prefix = items.find(
    (item) => item.enabled && item.path && pathname.startsWith(`${item.path}/`),
  );
  return prefix ?? null;
}
